module.exports = "https://la-static.prod-my.games/minigames/collection/img/upgrade.595a8ad1.svg";